import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { AuthenticationService } from "../authentication/authentication.service";
import { ApiGatewayService } from "../api-gateway/api-gateway.service";
import { TranslateService } from "../translate";
import { SnackbarService } from "../snackbar/snackbar.service";
import { LoggedInUser } from "../authentication/user";
import { UserName } from "./models";

@Component({
	selector: "sdp-name-change",
	templateUrl: "./name-change.component.html"
})
export class NameChangeComponent {
	public nameChangeForm: FormGroup;
	public isDataLoaded = true;

	private currentUser: LoggedInUser;

	constructor(
		private formBuilder: FormBuilder,
		private authService: AuthenticationService,
		private apiGatewayService: ApiGatewayService,
		private translateService: TranslateService,
		private snackbarService: SnackbarService,
	) {
		const cUser = this.authService.getCurrentUser();
		if (!cUser) {
			throw new Error("Unable to get curernt user.");
		}
		this.currentUser = cUser;

		this.nameChangeForm = this.formBuilder.group({
			firstName: [
				this.currentUser.firstName,
				Validators.required
			],
			lastName: [
				this.currentUser.lastName,
				Validators.compose([
					Validators.required,
				])
			]
		});
	}

	public async submit() {
		try {
			if (this.nameChangeForm.valid) {
				this.isDataLoaded = false;
				const data: UserName = {
					firstName: this.nameChangeForm.getRawValue().firstName,
					lastName: this.nameChangeForm.getRawValue().lastName
				};
				await this.apiGatewayService.updateUserName(data);
				this.isDataLoaded = true;
				// must set new name in the current user and save to local storage
				this.currentUser.firstName = this.nameChangeForm.getRawValue().firstName;
				this.currentUser.lastName = this.nameChangeForm.getRawValue().lastName;
				this.authService.saveCurrentUser(this.currentUser);
				this.snackbarService.open(this.translateService.translate("name-change.success"));
			}
		} catch (e) {
			this.isDataLoaded = true;
			this.snackbarService.open(this.translateService.translate(e));
		}
	}
}
